import { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '@/guards/AuthGuard';

// Import pages
import Login from '../pages/login';
import DashboardB2B from '../pages/dashboard/b2b';
import Tickets from '../pages/tickets/index';
import TicketsDetails from '../pages/tickets/details';
import OrderTickets from '../pages/orderTickets/index';
import NotFound from '../pages/404';
import UnAuthorized from '../pages/UnAuthorized';

import { PageWithLayout } from '@/models/page';

interface RouteConfig {
    path: string;
    component: PageWithLayout;
    isProtected?: boolean;
    permissions?: import('@/models/user').Permission[];
    layout?: 'sidebar' | 'split';
}

const routes: RouteConfig[] = [
    { path: '/login', component: Login, isProtected: false, layout: 'split' },
    {
        path: '/',
        component: DashboardB2B,
    },
    {
        path: '/dashboard/b2b',
        component: DashboardB2B,
    },
    {
        path: '/tickets',
        component: Tickets,
    },
    {
        path: '/tickets/details',
        component: TicketsDetails,
    },
    {
        path: '/ticket-bestellen',
        component: OrderTickets,
    },
    { path: '/404', component: NotFound },
    { path: '/unauthorized', component: UnAuthorized },
];

const RouteWrapper: FC<{ route: RouteConfig }> = ({ route }) => {
    const Component = route.component;

    const getLayout = Component.getLayout ?? ((page) => page);

    const render = () => getLayout(<Component />);

    if (Component.isProtected) {
        return <AuthGuard Component={Component}>{render()}</AuthGuard>;
    }

    return render();
};

export const AppRoutes: FC = () => {
    return (
        <Routes>
            {routes.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={<RouteWrapper route={route} />}
                />
            ))}
            <Route path='*' element={<Navigate to='/404' replace />} />
        </Routes>
    );
};
